import React, { useEffect } from "react";
import { COMPARE_STORE_CONTEXT } from "./CompareStore";
import classnames from "classnames/bind";
import { useObservableState } from "./UseObservableState";

export const CompareButton = (prop) => {
  const compareStore = React.useContext(COMPARE_STORE_CONTEXT);
  const isCompare = useObservableState(
    compareStore.isExistCompareProperty(prop)
  );

  function onAddCompareProperty() {
    compareStore.addCompareProperty(prop);
  }

  return (
    <div className="box-comparision">
      <i
        className={classnames([
          "ic-npa",
          "ic-npa-icon-compare",
          { "is-compare": isCompare },
        ])}
        onClick={onAddCompareProperty}
        data-kbct="open_popup" data-kblb="compare" data-kbgp="content_card" data-kbsc="relate_property" data-kbid={prop.PropertyID}
      ></i>
    </div>
  );
};

export const CompareButtonWithText = (prop) => {
  const compareStore = React.useContext(COMPARE_STORE_CONTEXT);
  const isCompare = useObservableState(
    compareStore.isExistCompareProperty(prop)
  );

  function onAddCompareProperty() {
    compareStore.addCompareProperty(prop);
  }

  return (
    <>
      <div
        className={classnames([
          "btn-compare",
          "box-comparision",
          "hide-xs",
          { "is-compare": isCompare },
        ])}
        onClick={onAddCompareProperty}
        data-kbct="open_popup" data-kblb="compare" data-kbgp="content_card" data-kbsc="relate_property" data-kbid={prop.PropertyID}
      >
        <i className="ic-npa ic-npa-icon-compare"></i>
        <span>เปรียบเทียบ{isCompare && "อยู่"}</span>
      </div>
    </>
  );
};
